import { Component, Input } from '@angular/core';
import { SearchResult } from '../../api/models/search-result';
import { AnalyticsService } from '../../shared/service/analytics/analytics.service';
import { CookieService } from 'ngx-cookie-service';
import { SearchEventTypeEnum } from '../../shared/model/search-event-type-enum';
import { SearchEventPublisher } from '../../shared/service/search-event-publisher.service';

@Component({
  selector: 'app-search-dym',
  templateUrl: './search-dym.component.html',
  styleUrls: ['./search-dym.component.scss'],
})
export class SearchDymComponent {
  @Input()
  searchResult?: SearchResult;

  constructor(
    private analyticsService: AnalyticsService,
    private cookieService: CookieService,
    private searchEventPublisher: SearchEventPublisher
  ) {}

  handleClick(mode: string): void {
    if (this.searchResult?.searchDym) {
      this.analyticsService.trackSearchInstead(this.searchResult.searchDym);
      const { originalTerm, originalParams, params } = this.searchResult.searchDym;

      if (params) {
        params.pg = 1;
      }

      if (
        'original' === mode &&
        null !== originalTerm &&
        undefined !== originalTerm &&
        null !== originalParams &&
        undefined !== originalParams
      ) {
        originalParams.pg = 1;
        this.cookieService.set('disable_auto_correct', originalTerm, { path: '/' });
        this.searchEventPublisher.publishEvent(SearchEventTypeEnum.SEARCH_FROM_DYM_REFRESH, originalParams);
      }

      if ('suggested' === mode && null !== params && undefined !== params) {
        this.cookieService.delete('disable_auto_correct', '/');
        this.searchEventPublisher.publishEvent(SearchEventTypeEnum.SEARCH_FROM_DYM, params);
      }
    }
  }

  shouldShowInstead(): boolean {
    return this.searchResult?.searchDym?.originalTerm !== this.cookieService.get('disable_auto_correct');
  }
}
